import { render, staticRenderFns } from "./ls-pagination.vue?vue&type=template&id=5d9e5435&scoped=true&"
import script from "./ls-pagination.vue?vue&type=script&lang=ts&"
export * from "./ls-pagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e5435",
  null
  
)

export default component.exports